<template>
  <div class="content blacklist">
    <div class="header">
      <div class="row">
        <div class="box">
          <span class="title">订单编号</span>
          <el-input class="input_box" size="small" v-model="params.ordersn"></el-input>
        </div>
        <div class="box">
          <span class="title">分销商手机号</span>
          <el-input class="input_box" size="small" v-model="params.spreader"></el-input>
        </div>
        <div class="box">
          <span class="title">买家手机号</span>
          <el-input class="input_box" size="small" v-model="params.buyer"></el-input>
        </div>
        <div class="box">
          <span class="title">状态</span>
          <!-- <el-radio-group size="small" v-model="params.status">
            <el-radio-button label="-1">全部</el-radio-button>
            <el-radio-button label="0">未结算</el-radio-button>
            <el-radio-button label="1">已结算</el-radio-button>
          </el-radio-group> -->
          <el-select class="input_box" size="small" v-model="params.status" clearable>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </div>
        <div class="box">
          <span class="title">开始时间</span>
          <el-date-picker
            size="small"
            v-model="params.start_date"
            type="date"
            style="width:130px"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          <el-time-picker
            arrow-control
            v-model="params.start_time"
            value-format="HH:mm"
            format="HH:mm"
            size="small"
            style="width:108px;margin-left:1px"
            placeholder="时间">
          </el-time-picker>
        </div>
        <div class="box">
          <span class="title">结束时间</span>
          <el-date-picker
            size="small"
            v-model="params.end_date"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:130px"
            placeholder="选择日期">
          </el-date-picker>
          <el-time-picker
            arrow-control
            v-model="params.end_time"
            value-format="HH:mm"
            format="HH:mm"
            size="small"
            style="width:108px;margin-left:1px"
            placeholder="时间">
          </el-time-picker>
        </div>
        <div class="box">
          <span class="title">变动原因</span>
          <el-select class="input_box" size="small" v-model="params.style" clearable>
            <el-option label="订单" value="1"></el-option>
            <el-option label="充值单" value="2"></el-option>
            <el-option label="邀请新人" value="4"></el-option>
          </el-select>
        </div>
        <div class="box">
          <span class="title">
            <el-button size="small" type="primary" @click="getData(1)">查询</el-button>
          </span>
        </div>
      </div>
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="变动原因" prop="show_style"></el-table-column>
        <el-table-column label="变动金额">
          <template slot-scope="scope">
            {{scope.row.show_type + scope.row.amount}}
          </template>
        </el-table-column>
        <el-table-column label="冻结金额" prop="frozen_amount"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column label="买家" prop="order.real_name"></el-table-column>
        <el-table-column label="推广人" prop="spreader.real_name"></el-table-column>
        <el-table-column label="状态" prop="show_status"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
      </el-table>
    </template>
    <div style="margin-top:20px">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="getData">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getSpreadMoney } from "@/api/user";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      params: {
        ordersn: "",
        spreader: "",
        buyer: "",
        status: "",
        style: "",
        start_date: "",
        start_time: "",
        end_date: "",
        end_time: ""
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData(i) {
      this.page = i || this.page;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        style: "1,2,4"
      }
      if(this.params.ordersn != ""){
        data.ordersn = this.params.ordersn
      }
      if(this.params.spreader != ""){
        data.spreader = this.params.spreader
      }
      if(this.params.buyer != ""){
        data.buyer = this.params.buyer
      }
      if(this.params.status != ""){
        data.status = this.params.status
      }
      if(this.params.style != ""){
        data.style = this.params.style
      }
      if(this.params.start_date && this.params.start_time && this.params.end_date && this.params.end_time){
        data.start_time = this.params.start_date + " " + this.params.start_time;
        data.end_time = this.params.end_date + " " + this.params.end_time; 
      }
      console.log('参数',data)
      getSpreadMoney(data).then(res => {
        if(res.code == 200) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.tableData.forEach(item => {
            item.show_style = item.style == 1? "订单":item.style == 2? "充值":item.style == 3? "提现":item.style == 4? "邀请新人":"其他"
            item.show_type = item.type == 1? "+":item.type == 2? "-":""
            item.show_status = item.status == 0? "未结算":"已结算"
          })
        }else{
          this.$message(res.msg);
        }
      })
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    
    .row{
      display: flex;
      padding: 6px 0;
      flex-wrap: wrap;
    }
    .box{
      width: 360px;
      line-height: 40px;
      .title{
        display: inline-block;
        padding-right: 15px;
        width:90px;
        text-align: right;
        font-size: 14px;
      }
      .input_box{
        display: inline-block;
        width: 240px;
      }
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
